import {Component, OnInit, HostBinding} from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {AnimationsMetaData} from '../_animations/animations.metadata';
import {Subscription} from 'rxjs/Subscription';
import {AnimationService} from '../_animations/animations.service';
import {RouteDirections, IRouteDirection} from '../_animations/route-directions.constant';

@Component({
  selector: 'app-home',
  providers: [AnimationService, RouteDirections],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [AnimationsMetaData]
})
export class HomeComponent implements OnInit {
  @HostBinding('@routing') routing;
  @HostBinding('style.display') display = 'block';
  animationServiceEventsSubscription: Subscription;
  public routeDirections: IRouteDirection[];

  constructor(private Title: Title,
              private Meta: Meta,
              private animationService: AnimationService,
              routeDirections: RouteDirections) {
    this.routeDirections = routeDirections.home;
  }

  ngOnInit() {
    this.Title.setTitle('Alec Bertram - Product Director | Technology Consultant');
    this.Meta.addTag({name: 'description', content: 'I\'m a London-based product professional and consultant, specialising in B2B SaaS. I\'m working to build tools and technology which make business easier. Visit now to find out more about my experience, consultancy, past projects, and awards. ' });
    this.routing = this.animationService.animationDirection();
    this.animationServiceEventsSubscription = this.animationService.emitCurrentDirection
      .subscribe((direction: any) => this.routing = direction);
  }

  go(direction: string, url: string) {
    return this.animationService.routingService(direction, url);
  }

  pan($event, url: string) {
    return this.animationService.mobileRoutingSerivce($event, url);
  }
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/home/home.component.ts